import React from 'react';
import { translate } from '@utils/i18n';
import { DashboardCard } from '@ui/molecules/DashboardCard';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
const BAR_HEIGHT = 120;
function DismissedVsResolvedChart({ data, isLoading, className }) {
    return (React.createElement(DashboardCard, { title: translate('bottom.dismissed_vs_resolved', { namespace }), subtitle: translate('bottom.dismissed_subtitle', { namespace }), isLoading: isLoading, className: className }, data.length === 0 ? (React.createElement("p", null, translate('chart.no_data', { namespace }))) : (React.createElement("div", { className: "dismissed-resolved-chart__grid" }, data.map((item) => {
        const resolvedPct = item.resolved;
        const isLow = resolvedPct < 50;
        const resolvedHeight = Math.round((resolvedPct / 100) * BAR_HEIGHT);
        const dismissedHeight = BAR_HEIGHT - resolvedHeight;
        return (React.createElement("div", { key: item.category, className: "dismissed-resolved-chart__column" },
            React.createElement("span", { className: "dismissed-resolved-chart__label" }, translate(`bottom.issue_types.${item.category}`, { namespace })),
            React.createElement("div", { className: "dismissed-resolved-chart__bar", style: { height: BAR_HEIGHT } },
                React.createElement("div", { className: "dismissed-resolved-chart__segment dismissed-resolved-chart__segment--dismissed", style: { height: dismissedHeight } }),
                React.createElement("div", { className: "dismissed-resolved-chart__segment dismissed-resolved-chart__segment--resolved", style: { height: resolvedHeight } })),
            React.createElement("span", { className: `dismissed-resolved-chart__pct${isLow ? ' dismissed-resolved-chart__pct--low' : ''}` },
                resolvedPct,
                "% ",
                translate('bottom.resolved', { namespace }))));
    })))));
}
export default DismissedVsResolvedChart;
